import { render, staticRenderFns } from "./PatientWeightTab.vue?vue&type=template&id=02ecd2dc&scoped=true&"
import script from "./PatientWeightTab.vue?vue&type=script&lang=js&"
export * from "./PatientWeightTab.vue?vue&type=script&lang=js&"
import style0 from "./PatientWeightTab.vue?vue&type=style&index=0&id=02ecd2dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ecd2dc",
  null
  
)

export default component.exports